/**
 * Defer execution of the function f until currently queued tasks have
 * completed. This is useful if you want to do some processing after the current
 * round of event handlers has finished running.
 * @function defer
 */


export const defer = (f: (args: any[]) => any) => {
    setTimeout(f, 0);
};

export default defer;
